import React, { useEffect, useState } from 'react';
import { getSignRequirements, IDocuSignData } from '../../../../common/services/http/docuSignService';
import Icon from '../../../ui/icon/icon';
import useTranslate from '../../../../common/hooks/useTranslate';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { SWITCH_MODAL, SWITCH_REDIRECTING_TO_DS_MODAL } from '../../../../redux/types';

import './docuSign.scss';
import { Link } from 'react-router-dom';

const DocuSign: React.FC = () => {
  const [signData, setSignData] = useState([]);
  const [showDocuSign, setShowDocuSign] = useState(true);

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const impersonate = useSelector((state: RootState) => state.impersonate.impersonate);
  const docuSignDropdown = useSelector((state: RootState) => state.docuSignDropdown.docuSignDropdown);

  useEffect(() => {
    getSignRequirements().then((res: IDocuSignData[]) => {
      setSignData(res);
    });
  }, [impersonate, docuSignDropdown]);

  const goToDocuSign = (item: IDocuSignData): void => {
    if (impersonate) {
      dispatch({ type: SWITCH_MODAL });
    } else {
      dispatch({ type: SWITCH_REDIRECTING_TO_DS_MODAL, payload: item });
    }
  };

  const closeDocuSignInfo = (): void => {
    setShowDocuSign(false);
  };

  return (
    <>
      {showDocuSign && signData && signData.length > 0 && (
        <div className='docusign-wrapper'>
          <div className='docusign-left hidden-mobile'>
            <span className='action-required-span'>{t('HOME.DOCUSIGN_ACTION_REQUIRED')}</span>
          </div>
          <div className='docusign-docs hidden-mobile'>
            {signData.map(
              (item, key) =>
                !item.isSigned && (
                  <div className='docusign-item-wrapper pointer' key={key} onClick={() => goToDocuSign(item)}>
                    <span>{item.name}</span>
                  </div>
                ),
            )}
          </div>
          <div className='docusign-docs hidden-desktop'>
            {signData.length > 0 && signData.length < 2 ?
              signData.map(
                (item, key) =>
                  !item.isSigned && (
                    <div className='docusign-item-wrapper pointer' key={key} onClick={() => goToDocuSign(item)}>
                      <span>{item.name}</span>
                    </div>
                  ),
              )
              :
              <Link className='docusign-item-wrapper pointer' to='/docusign/sign'>
                {t('HOME.DOCUSIGN_ACTION_REQUIRED')}
              </Link>
            }
          </div>
          <div className='docusign-right'>
            <Icon name='fas fa-arrow-alt-to-bottom' className='docusign-icon' />
          </div>
          <Icon name='fas fa-times-circle' className='close-circle-btn pointer' onClick={closeDocuSignInfo} />
        </div>
      )}
    </>
  );
};

export default DocuSign;
